<template>
  <div class="user">
    <div class="photo">
      <img src="/img/wavycat/hotel.png" />
    </div>
    <div class="user-info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click.stop="toggleMenu" @click.capture="clicked">
        <span v-if="selectedHotel">
          {{ selectedHotel.name }}
          <b class="caret" v-if="hotels.length > 1"></b>
        </span>
      </a>

      <collapse-transition v-if="hotels.length > 1">
        <div v-show="!isClosed" class="hotel-list  md-scrollbar md-theme-default">
          <ul class="nav">
            <li v-for="hotel in hotels" :key="hotel.id">
              <a @click="changeHotelSelected(hotel)">
                <span class="sidebar-mini">{{ linkPrefix(hotel.name) }}</span>
                <span class="sidebar-normal">{{ hotel.name }}</span>
              </a>
            </li>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import Api from '@/openapi/src/api/HotelApi.js'
import { CollapseTransition } from 'vue2-transitions'
import { HotelSettingsApi } from '@/openapi/src'

export default {
  components: {
    CollapseTransition,
  },
  props: {
    title: {
      type: String,
      default: 'Hotel La Veleta',
    },
    avatar: {
      type: String,
      default: './img/faces/avatar.jpg',
    },
  },
  computed: {
    selectedHotel() {
      return this.hotels.find((h) => h.id == this.$root.hotelId)
    },
  },
  data() {
    return {
      isClosed: true,
      hotels: [],
    }
  },
  methods: {
    linkPrefix(name) {
      if (name) {
        let words = name.split(' ')
        return words.map((word) => word.substring(0, 1)).join('')
      }
      return false
    },
    clicked: function(e) {
      e.preventDefault()
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed
    },
    reloadPage() {
      location.reload()
    },
    changeHotelSelected(hotel) {
      this.$root.setHotelId(hotel.id)

      new HotelSettingsApi().getHotelSettings(hotel.id, (error, data) => {
        if (!error) {
          sessionStorage.setItem('currency', data.settings_dto.currency)
          sessionStorage.setItem('show-decimals', data.settings_dto.show_decimals)
          this.toggleMenu()
          this.reloadPage()
        }
      })
    },
  },
  created() {
    new Api().getHotels((error, data) => {
      this.hotels = data
      if (!this.$root.hotelId && this.hotels.length) {
        let hotelId = this.hotels[0].id
        if (sessionStorage.getItem('hotel') && this.hotels.some((h) => h.id.toString() === sessionStorage.getItem('hotel'))) {
          hotelId = sessionStorage.getItem('hotel')
        } else if (localStorage.getItem('hotel') && this.hotels.some((h) => h.id.toString() === localStorage.getItem('hotel'))) {
          hotelId = localStorage.getItem('hotel')
        }
        this.$root.setHotelId(hotelId)
        new HotelSettingsApi().getHotelSettings(hotelId, (error, data) => {
          if (!error) {
            sessionStorage.setItem('currency', data.settings_dto.currency)
            sessionStorage.setItem('show-decimals', data.settings_dto.show_decimals)
          }
        })
      }
    })
  },
}
</script>
<style>
.collapsed {
  transition: opacity 1s;
}

.hotel-list {
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>
